'use client';

import styles from './style.module.scss';
import classes from './style.module.scss';

import { cn } from '@/lib/utils';

import { articleStore } from '@/store/article';

import { StateArticle } from '@/models/States';

import ShareArticleModal from '../SocialMedia/ShareArticleModal';

export default function ModalContainer({ modal }: { modal: React.ReactNode }) {
  const article = articleStore((store: StateArticle) => store.story);

  return (
    <>
      <div
        className={cn(
          classes.modalContainer,
          article.opened ? styles.open : styles.hidden,
        )}
      >
        {modal}
        <div id='modal-root' />
      </div>
      <ShareArticleModal />
    </>
  );
}
